module.exports = __webpack_public_path__ + "img/logo-footer-rumodigital-01.ec260e23.png";